import * as React from 'react';
import { SvgIcon } from '@mui/material';
function wrapWithSvgIcon(component, props) {
    return React.createElement(SvgIcon, Object.assign({}, props), component);
}
function SvgBarChart(props) {
    return wrapWithSvgIcon(React.createElement("svg", Object.assign({ xmlns: "http://www.w3.org/2000/svg", width: 24, height: 24, fill: "currentColor" }, props),
        React.createElement("path", { fillRule: "evenodd", d: "M10.6 5h2.8v14h-2.8V5zM5 9.2h3V19H5V9.2zM19 13h-2.8v6H19v-6z", clipRule: "evenodd" })), props);
}
export default SvgBarChart;
//# sourceMappingURL=BarChart.js.map